// Resolves the active Home v2 layout tier from the live window width.
// Web-only (consumes useWindowSize.web). Mirrors the design's three tiers.
import useWindowSize from '@common/hooks/useWindowSize'

import { BREAKPOINTS } from './tokens'

export type HomeLayout = {
  /** >= 1200px: sidebar + two-column grid. */
  isDesktop: boolean
  /** 768–1199px: sidebar + single column (right column stacks under left). */
  isStacked: boolean
  /** < 768px: bottom tab bar, single column, sheets for detail/activity. */
  isMobile: boolean
  width: number
}

const useHomeBreakpoints = (): HomeLayout => {
  const { width } = useWindowSize()

  const isMobile = width < BREAKPOINTS.tablet
  const isDesktop = width >= BREAKPOINTS.desktop
  const isStacked = !isMobile && !isDesktop

  return { isDesktop, isStacked, isMobile, width }
}

export default useHomeBreakpoints
